import { render, staticRenderFns } from "./Trusted-customers.vue?vue&type=template&id=3591d674&scoped=true"
import script from "./Trusted-customers.vue?vue&type=script&lang=js"
export * from "./Trusted-customers.vue?vue&type=script&lang=js"
import style0 from "./Trusted-customers.vue?vue&type=style&index=0&id=3591d674&prod&scoped=true&lang=css"
import style1 from "./Trusted-customers.vue?vue&type=style&index=1&id=3591d674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591d674",
  null
  
)

export default component.exports